var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-full h-full capitalize",class:{
    'text-gray-text': _vm.additional[_vm.type] != _vm.active,
    'text-dark bg-gray-light': _vm.additional[_vm.type] == _vm.active
  },attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.active == 'expenses' ? 'Exp.' : 'Rev.'))])
}
var staticRenderFns = []

export { render, staticRenderFns }